class ImageGalleryItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Get the header background color
        const headerBg = this.getAttribute('data-header-bg') || 'red';

        // PMC Color palette mapping
        const colorMapping = {
            'pmc-orange': '#E0604B',
            'rich-black': '#000000',
            'pmc-deep-gray': '#313131',
            'pmc-silver': '#B2B4B6',
            'pmc-light-gray': '#F0F0F0',
            'white': '#FFFFFF',
            'mills-red': '#A41E34',
            'veridian-green': '#40826D',
            'veridian-green-dark': '#255447',
            'veridian-green-light': '#BCE8E0',
            'riverwalk-blue': '#0777BD',
            'riverwalk-dark-blue': '#0E65A0',
            'riverwalk-light-blue': '#2CAAE2',
            'color-guide-dark': '#004D64',
            'color-guide-deep': '#000021',
            'color-guide-gold': '#C3996B',
            // Legacy support
            'red': '#A41E34',
            'palmetto-gray': '#313131'
        };

        // Find gallery elements within this block
        const galleryElements = this.querySelectorAll('.image-gallery-item__element');

        // Add click event listeners to apply theme color when gallery opens
        galleryElements.forEach(element => {
            element.addEventListener('click', () => {
                // Set the gallery theme on body when lightgallery opens
                setTimeout(() => {
                    document.body.setAttribute('data-gallery-theme', headerBg);
                    // Set CSS variable with the correct color value
                    const colorValue = colorMapping[headerBg] || '#A41E34';
                    document.documentElement.style.setProperty('--gallery-theme-color', colorValue);
                }, 100);
            });
        });

        // Listen for gallery close event to clean up
        document.addEventListener('lgAfterClose', () => {
            document.body.removeAttribute('data-gallery-theme');
            document.documentElement.style.removeProperty('--gallery-theme-color');
        });
    }
}

customElements.define('image-gallery-item', ImageGalleryItem, {extends: 'section'});